<script lang="ts">
  import { createEventDispatcher } from "svelte"

  import { createErrorNotice, GENERIC_ERROR_MESSAGE } from "@util/notices"
  import { isEmptyObject, reduceErrors, ValidationErrors } from "@util/validations"

  export let submit: () => Promise<any> | undefined = undefined
  export let validate: any = undefined
  export let data: any

  let dispatch = createEventDispatcher()

  let submitting = false
  let submitted = false
  let touched = false

  let apiErrors = {}

  $: validationErrors = validate ? validate(data) : {}
  $: errors = isEmptyObject(validationErrors) ? apiErrors : validationErrors

  async function doSubmit() {
    touched = true
    submitted = true

    if (isEmptyObject(validationErrors)) {
      submitting = true
      let redirected = false

      if (submit) {
        try {
          let result = await submit()

          if (result.ok) {
            apiErrors = {}
            let { meta } = result.body

            if (meta.redirect) {
              let state = { flash: meta.flash }
              history.pushState(state, null, meta.redirect)
              history.go()
              redirected = true
            }
          } else if (!result.body.errors?.toplevel) {
            apiErrors = reduceErrors(result.body.errors)
          }
        } catch (e) {
          // leave this console log, should never happen unless we have an
          // actual coding error
          console.log(e)
          createErrorNotice(GENERIC_ERROR_MESSAGE)
        }
      }
      if (!redirected) {
        // if redirected we don't enable submit button and wait for page reload
        submitting = false
      }
    }
  }

  function dispatchChange(e) {
    touched = true
    apiErrors = {}

    dispatch("change", e)
  }
</script>

<form on:change={dispatchChange} on:submit|preventDefault={doSubmit}>
  <slot {submitting} {submitted} {touched} {errors} />
</form>
